// eslint-disable-next-line no-unused-vars
import React, {useState, useReducer, createContext, useEffect, useRef, lazy, Suspense} from "react";
import RequestService from "../../utils/fetch";
import {Button} from "@ariakit/react";

//Jobagent payload example:
// {"search":{"filter":{"operatingarea":["Ausbildung","Banking und Finanzdienstleistung","Controlling/Finanz- und Rechnungswesen","Elektrik/Elektronik/Elektrotechnik"],"geoLocation":{"lat":49.0134297,"lng":12.1016236,"radius":80,"label":"Regensburg, Deutschland"}}},"interval":"BI_WEEKLY"}

// import {endPointsNonTrmEdition, endPointsTrmEdition} from "./Endpoints";
// import translations from "../../translations/index";
const Register = lazy(() => import("./Register"));
const Actions = lazy(() => import("./Actions"));
const Login = lazy(() => import("./Login"));
const LoggedIn = lazy(() => import("./LoggedIn"));
const Success = lazy(() => import("./Success"));
const RecoverPassword = lazy(() => import("./RecoverPassword"));
const TmsErrorHandler = lazy(() => import("../TmsErrorHandler"));

import errorHandlerReducer from "../TmsErrorHandler/errorHandlerReducer";
import {isNotEmptyArray} from "../../utils/IsNotEmptyArray";
import translations from "../../translations";
import {endPointsJobAgent, endPointsTrmEdition} from "../../utils/Endpoints";

// const candidateWidgetReducer = (state, action) => {
//
//     console.log(state, action);
//
//     switch (action.type) {
//
//     case "REGISTER_CANDIDATE" :
//         // handleRegister(action.payload);
//         break;
//     default:
//         break;
//     }
// };


export const ConfigContext = createContext(null); // TODO: Rename var

function TmsCandidateWidget() {
    const [componentUUID] = useState(Date.now());
    const [translation, setTranslation] = useState({});
    const submitButtonRef = useRef(null);
    const [hasError, setHasError] = useState(false);
    const [hasSuccess, setHasSuccess] = useState(false);
    const [errorTimeout, setErrorTimeout] = useState(null);
    const [errorState, dispatchError] = useReducer(errorHandlerReducer, {
        hasError: false,

    });
    // const [registerState, dispatchRegister] = useReducer(candidateWidgetReducer, {});

    const customDataAttributes = document.querySelector("tms-candidate-widget").dataset;
    // default view is to register
    const [currentState, setState] = useState(() => {

        if (["register", "login", "recover"].indexOf(customDataAttributes.state) !== -1) {
            return customDataAttributes.state;
        }
        return "register";
    });

    // Reset Errorobject when state changes and is filled
    useEffect(() => {

        if (currentState !== "register" && isNotEmptyArray(errorObject)) {
            setErrorObject([]);
        }
    }, [currentState]);
    useEffect(() => {

        setTranslation(translations[config.lang] ? translations[config.lang] : translations["de"]);

        const checkAuthentication = async () => {
            return await RequestService.postRequest(`${config.clientURL}${endPointsTrmEdition.authentication}`);
        };
        checkAuthentication().then(data => {
            if (data.authenticated) {
                document.documentElement.classList.remove("tms-is-not-logged-in");
                document.documentElement.classList.add("tms-is-logged-in");
                setState("loggedin");
            }
            document.documentElement.classList.add("tms-is-not-logged-in");

        });

    }, []);


    useEffect(() => {
        const {hasError} = errorState;

        if (hasError) {
            setTimeout(() => {
                dispatchError({
                    type: "error",
                    payload: {
                        hasError: false
                    }
                });
            }, 1000);
        }
    }, [errorState]);

    const [errorObject, setErrorObject] = useState([]);
    const [registerObject, setRegisterObject] = useState({
        customProperties: {},
        email: null,
        toc: null
    });

    const [loginObject, setLoginObject] = useState({
        email: "",
        password: ""
    });


    useEffect(() => {
        let errorTimeout;

        if (errorObject.length === 0) {
            // Hier brauchen wir kein clearTimeout, da noch kein Timeout gesetzt wurde
            if (submitButtonRef.current !== null) {
                submitButtonRef.current.disabled = false;
            }
            return;
        }

        // Timeout nur setzen wenn errorObject nicht leer ist
        errorTimeout = setTimeout(() => {
            // setErrorObject([]);
            if (submitButtonRef.current !== null) {
                submitButtonRef.current.disabled = false;
            }
        }, 2000);


        // Cleanup-Funktion für den Fall, dass der Effect erneut ausgeführt wird
        return () => {
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }
        };
    }, [errorObject]);
    const hasAllRequiredFields = () => {
        const requiredItems = config.talentnetwork.filter(item => {
            return item.required;
        })
            .map(item => item.name);
        const errorList = [];
        requiredItems.forEach(requiredItem => {
            const currentField = config.talentnetwork.find(field => field.name === requiredItem);
            switch (currentField.property) {
            case false:
                if ((registerObject[requiredItem]) && (registerObject[requiredItem]).length) {
                    return true;
                }
                errorList.push(config.talentnetwork.filter(item => item.name === requiredItem)[0]);
                break;
            case "custom":
                if ((registerObject.customProperties[requiredItem]) && (registerObject.customProperties[requiredItem]).length) {
                    return true;
                }
                errorList.push(config.talentnetwork.filter(item => item.name === requiredItem)[0]);
            }
        });

        const hasCheckedToc = document.querySelector(`input#toc--${componentUUID}:checked`);
        if (hasCheckedToc === null) {
            errorList.push({
                errorName: translations[config.lang || "de"].acceptDataProtection,
            });
        }

        if (errorList.length) {
            const errors = errorList.map(error => {
                return {
                    name: error.name,
                    message: error.errorName,
                    type: "error"
                };
            });
            setErrorObject(errors);
            setHasError(true);
            return false;

        }
        return true;
    };
    const handleLogin = () => {
        submitButtonRef.current.disabled = true;

        RequestService.postRequest(`${config.clientURL}${endPointsTrmEdition.login}`, {
            username: loginObject.email,
            password: loginObject.password

        })
            .then(data => {

                const {success} = data;
                if (success) {
                    setState("loggedin");
                }
                submitButtonRef.current.disabled = false;
                setErrorObject([{
                    name: "COULD_NOT_LOG_IN",
                    message: "Bitte E-Mail/Passwort prüfen",
                    type: "error"
                }]);
                setHasError(true);
            });

    };
    const handleRecoverPassword = () => {
        submitButtonRef.current.disabled = true;

        const userName = document.querySelector("[name=email]");

        RequestService.postRequest(`${config.clientURL}${endPointsTrmEdition.password}`, {
            email: userName.value,

        })
            .then(data => {
                if (data.success) {
                    setHasError(false);
                    setHasSuccess(true);
                    setErrorObject([{
                        type: "success",
                        name: "SUCCESS",
                        message: data.message
                    }]);
                    return true;
                }

                setErrorObject([{
                    name: "COULD_NOT_LOG_IN",
                    message: data.errors[0].message || "Fehler"
                }]);
            });

    };
    const handleAddJobagent = (jobagentObject) => {
        RequestService.postRequest(`${config.clientURL}${endPointsJobAgent.create}`, {
            ...jobagentObject
        })
            .then(data => {
                if (data.success) {
                    setState("success");
                    handleLogout();
                    return true;
                }
                setState("register");
                setErrorObject([{
                    name: "JOBAGENT_NOT_CREATED",
                    message: "Jobagent konnte nicht angelegt werden."
                }]);
                setHasError(true);

            });
    };

    const handleErrorDismiss = () => {
        setErrorTimeout(() => {

        });
        setErrorObject([]);

    };

    const handleLogout = () => {
        RequestService.postRequest(`${config.clientURL}${endPointsTrmEdition.logout}`)
            .then(data => {
                if (data.success) {
                    return true;
                }
            });
    };
    const handleRegister = () => {
        submitButtonRef.current.disabled = true;
        submitButtonRef.current.value = translations[config.lang || "de"].candidateWidgetIsSending;

        if (hasAllRequiredFields()) {
            setState("success");
            RequestService.postRequest(`${config.clientURL}${endPointsTrmEdition.register}`, {
                ...registerObject,
                autoLogin: config.jobagent || false,
                lang: config.lang || "de",
                locale: config.lang || "de"
            })
                .then(data => {
                    if (data.success === false) {
                        setErrorObject([{
                            name: "ALREADY_USED",
                            message: "Bitte E-Mail/Passwort prüfen"
                        }]);
                        setHasError(true);
                        setState("register");

                    }

                    const jobagentPayload = JSON.parse(JSON.stringify(jobagentObject));
                    const listOfNames = config.talentnetwork.reduce((results, element) => {
                        if (element.jobagent) {
                            results.push(element.name);
                        }
                        return results;
                    }, []);
                    if (registerObject.customProperties) {

                        for (let i = 0; i < listOfNames.length; i++) {
                            const name = listOfNames[i];
                            if (registerObject.customProperties[name].length) {
                                jobagentPayload.search.filter[name] = registerObject.customProperties[name];
                            }
                        }

                    }

                    if (data.success) {
                        if (config.jobagent) {
                            handleAddJobagent(jobagentPayload);
                            return true;
                        }

                    }


                })

                .finally(() => {
                    if (submitButtonRef.current !== null) {
                        submitButtonRef.current.disabled = false;
                    }
                });
        }

        return false;

    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setErrorObject([]);
        switch (currentState) {
        case "register":
            return handleRegister();
        case "login":
            return handleLogin();
        case "recover":
            return handleRecoverPassword();

        default:
            return true;

        }

    };

    const handleSelectChange = (newInputData, field) => {

        // if (newInputData.length === 0) {
        //     return false;
        // }

        // we loop through all passed values and create a new object to pass to our registerobject
        let value = "";
        if (field.multiple) {
            value = [];
            for (let i = 0; i < newInputData.length; i++) {

                const data = newInputData[i];
                value.push(data.value);

            }
        } else {
            value = newInputData[0]?.value || "";
        }
        let output = false;
        setRegisterObject((currentRegisterObject) => {

            output = {
                ...currentRegisterObject,
                [field.name]: value
            };

            if (field.property) {
                output = {
                    ...currentRegisterObject,
                    customProperties: {
                        ...currentRegisterObject.customProperties,
                        [field.name]: value
                    }
                };
            }
            return output;

        });
    };
    const handleInputChange = (newInputData, field = [{}]) => {

        console.log(newInputData, "onchange");
        let value;


        switch (newInputData.target?.type) {

        case "checkbox":
            value = newInputData.target.checked;
            break;

        case "text":
            value = newInputData.target.value;
            break;
        case undefined:
            value = newInputData.value;
            break;
        default:
            break;
        }

        let output = false;
        setRegisterObject((currentRegisterObject) => {

            output = {
                ...currentRegisterObject,
                [field.name]: value
            };

            if (field.property) {
                output = {
                    ...currentRegisterObject,
                    customProperties: {
                        ...currentRegisterObject.customProperties,
                        [field.name]: value
                    }
                };
            }
            return output;

        });

    };

    const handleInputValue = (field) => {
        const {property} = field;

        // comment see handleSelectChange
        if (property) {
            return registerObject.customProperties[field.name];
        }
        if (registerObject[field.name] === null) {
            return undefined;
        }

        return registerObject[field.name];

    };

    const [config, setConfig] = useState(() => {
        const configName = "myTalentionConfig";

        const currentConfig = window[configName] || {};
        if (Object.keys(currentConfig).length) {
            return currentConfig;
        }
        // dispatch error if config is empty
        // TODO: Is this an anti-pattern?
        // TODO: ANTI_PATTERN
        dispatchError({
            type: "error",
            payload: {
                hasError: true,
                type: "error",
                code: "CONFIG_NOT_FOUND",
                description: "Config was not found.",
            }
        });
    });
    const [jobagentObject, setJobagentObject] = useState({
        search: {
            filter: {
                category: config.category || []
            }, // Insert the filter query exactMatch
            exactMatch: true // false or true
        },
        interval: config.jobagentInterval || "MONTHLY" //One of: WEEKLY, BI_WEEKLY, MONTHLY, QUARTERLY
    });

    if (errorState.hasError) {
        return <TmsErrorHandler error={errorState}/>;
    }
    if (!config.trmEdition) {
        return <TmsErrorHandler error={
            {
                hasError: true,
                type: "error",
                code: "V3_FLAG_IN_CONFIG_MISSING",
                description: "\"trmEdition:true\" is required in myTalentionConfig.",
            }
        }/>;
    }
    return (
        <ConfigContext.Provider value={{
            handleInputValue,
            handleInputChange,
            handleSelectChange,
            config,
            registerObject,
            setRegisterObject,
            setJobagentObject,
            jobagentObject,
            setState,
            translation,
            errorObject
        }}>
            <>
                <form onSubmit={handleSubmit} noValidate={true}
                    className={currentState}
                    data-component-uuid={componentUUID}>
                    {currentState === "register" &&
                        <Register componentUUID={componentUUID}/>
                    }
                    {currentState === "login" &&
                        <Login setLoginObject={setLoginObject} loginObject={loginObject}/>}
                    {currentState === "recover" &&
                        <RecoverPassword setLoginObject={setLoginObject} loginObject={loginObject}/>}
                    {currentState === "loggedin" && <LoggedIn/>}
                    {currentState === "success" && <Success/>}
                    <Actions submitButtonRef={submitButtonRef} state={currentState}/>
                </form>
                {errorObject.length > 0 ?
                    <div className={"tms-candidate-widget-errors-wrapper"}>
                        <Button
                            type="button"
                            onClick={() => {
                                handleErrorDismiss();
                            }}
                            className="tms-candidate-widget-errors-close-button"
                            aria-label="Fehlermeldungen schließen"
                        >
                            ×
                        </Button>
                        <ul className={`tms-candidate-widget-errors${hasError ? " has-error" : ""}${hasSuccess ? " has-success" : ""}`}>{errorObject.map((error, key) =>
                            <li
                                className={error.type || "error"}
                                key={error.name + key}>{error.message}</li>)}</ul>
                    </div> : null}
            </>
        </ConfigContext.Provider>

    );
}

export default TmsCandidateWidget;
